import { IPatientMonitoringPauseDto } from '~/services/api/patientMonitoringPauses/types';
import { IPauseMonitoringFormValues } from '../types';

const getInitialValues = (
  currentMonitoringPause?: IPatientMonitoringPauseDto | null,
): IPauseMonitoringFormValues =>
  currentMonitoringPause
    ? {
        ...currentMonitoringPause,
      }
    : {
        startDate: '',
        endDate: '',
        reason: '',
      };

export default getInitialValues;
